import store from '@/store';
import { p2pActions } from '@/store/p2p-slice';

import { notAuthHandler } from './notAuthHandler';
import { sendP2PSocketData } from './p2pConnection';

export const disconnectPeerHandler = () => {
    // clear request join interval if joined or disconnected
    notAuthHandler(null, true);

    const isInUploadKeyPage = store.getState().p2pReducer.isInUploadKeyPage;
    const activeServer = store.getState().serverDataReducer.activeServer;

    const serverDetails =
        store.getState().serverDataReducer.serverData?.[activeServer];
    const privateKey = serverDetails?.privateKey ?? '';

    if (!isInUploadKeyPage && privateKey && privateKey !== undefined) {
        sendP2PSocketData({
            command: 'setavailable',
            data: [],
        });
    } else {
        store.dispatch(p2pActions.updatePeerFound('Searching for peers'));
        sendP2PSocketData({
            command: 'getpeer',
            data: [],
        });
    }
};
